import { businessDetailsSlice } from './slice';

export const {
  updateCoverStart,
  updateDutyOfDisclosure,
  updateIndustry,
  updateIndustryOnly,
  updateOccupationCategory,
  updateOccupationCategoryOnly,
  updateOccupation,
  updateOccupationItem,
  updateOccupationsList,
  updateEmployeeCount,
  updateAnnualTurnover,
  updateBusinessAddress,
  updateFullBusinessAddress,
  updateAddressLine1,
  updateSuburb,
  updateState,
  updatePostcode,
  updateIsValidAddress,
  updateIsVerifiedAddress,
  updatePerils,
  updatePropertyValue,
  clearManualAddress,
  clearPerils,
  clearLookedupAddress,
  updateShowAllOccupationCategories,
  updateOccupationSearchType,
  updateInsuredType,
  updatePropertyType,
  updatePropertyOwnerOccupation,
  updateIsManualEntry,
} = businessDetailsSlice.actions;

export * from './types';
